<template>
  <div class="rp-dual-ring"></div>
</template>

<script>
export default {name: 'Spinner'}
</script>

<style lang="sass" scoped>
@import '../../styles/base/_variables.sass'

.rp-dual-ring
  display: inline-block
  width: 20px
  height: 20px

.rp-dual-ring:after
  content: " "
  display: block
  width: 25px
  height: 25px
  border-radius: 50%
  border: 3px solid #fff
  border-color: $color-primary transparent $color-primary transparent
  animation: rp-dual-ring 1.2s linear infinite

@keyframes rp-dual-ring
  0%
    transform: rotate(0deg)

  100%
    transform: rotate(360deg)
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Spinner.vue